import { useTranslation } from "react-i18next";
import AdminLayout from "@/components/admin/AdminLayout";
import CodSettings from "@/components/admin/CodSettings";
import WhatsappSettings from "@/components/admin/WhatsappSettings";
import { useAdminPageTitle } from "@/hooks/admin/useAdminPageTitle";
import { useAdminAuth } from "@/context/AdminAuthContext";

export default function Settings() {
  const { t } = useTranslation("admin");
  const { user } = useAdminAuth();
  useAdminPageTitle("Paramètres");

  // WhatsApp bridge settings are restricted to super_admin and Direction department
  const canManageWhatsapp =
    user?.role === "super_admin" || user?.departmentName === "Direction";

  return (
    <AdminLayout>
      <div className="space-y-6">
        <div className="space-y-1">
          <h1 className="font-display text-2xl font-semibold text-stone-900">
            {t("nav.settings")}
          </h1>
          <p className="text-sm text-stone-500">
            Configurez les paramètres de paiement et les options générales.
          </p>
        </div>

        {/* CoD settings — already built by CoD agent */}
        <CodSettings />

        {/* WhatsApp bridge settings — super_admin / Direction only */}
        {canManageWhatsapp && (
          <section>
            <div className="mx-auto max-w-2xl space-y-2 rounded-xl border border-border bg-card p-6 md:p-8">
              <div className="mb-6">
                <h2 className="font-display text-2xl font-semibold text-foreground">
                  Paiements WhatsApp
                </h2>
                <p className="text-sm text-muted-foreground mt-1">
                  Configuration du bridge de paiement manuel via WhatsApp.
                </p>
              </div>
              <WhatsappSettings />
            </div>
          </section>
        )}
      </div>
    </AdminLayout>
  );
}
